import log from 'loglevel';
import axios from 'axios';

log.setLevel('INFO');

export const debug = (value: string) => {
  log.debug(value);
};

export const info = (value: string) => {
  log.info(value);
  saveActionLog('INFO', value);
};

export const warn = (value: string) => {
  log.warn(value);
  saveActionLog('WARN', value);
};

export const error = (value: string) => {
  log.error(value);
  saveActionLog('ERROR', value);
};

const saveActionLog = (level: string, value: string) => {
  const user_url: string = window.location.href;
  axios
    .post(
      `/api/v1/action-log`,
      {
        user_url,
        level,
        value
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .catch(err => {
      if (err.response) {
        log.error(err.response.data);
      } else if (err.request) {
        log.error(err.request);
      } else {
        log.error(err.message);
      }
    });
};
